import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { projectPropertiesPropTypes } from '../../../../utils/propTypes';
import RequestTreeList from '../../../requestTreeList';
import { useHistory } from 'react-router-dom';
import Icon from 'front-onceforall-core/dist/components/Icon';
import CreateRequestForApprovalButton from '../../../buttons/createRequestForApprovalButton';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectRequestListView = props => {
  const history = useHistory();
  const groupedRequests = sortedRequests(Object.entries(groupByRfaOwner(props.requests)));
  function sortedRequests(requests) {
    return requests.map(group => {
      return {
        rfaOwnerName: getOrganisationName(group[0]),
        rfaOwnerRegistrationNumber: getOrganisationRegistrationNumber(group[0]),
        rfaOwnerRequests: group[1]
      };
    }).sort((a, b) => {
      return a.rfaOwnerName < b.rfaOwnerName ? -1 : a.rfaOwnerName > b.rfaOwnerName ? 1 : 0;
    });
  }
  function groupByRfaOwner(requests) {
    return requests.reduce((accumulator, value) => {
      (accumulator[value.creatorOrganisationId] = accumulator[value.creatorOrganisationId] || []).push(value);
      return accumulator;
    }, {});
  }
  function getOrganisationName(id) {
    return props.organisations.find(organisation => organisation.id === Number(id))?.fullName;
  }
  function getOrganisationRegistrationNumber(id) {
    return props.organisations.find(organisation => organisation.id === Number(id))?.registrationNumber;
  }
  const groupedList = groupedRequests.map((rfaOwner, index) => {
    return /*#__PURE__*/_jsxs("div", {
      className: "card col-12",
      children: [props.organisations.length > 0 && /*#__PURE__*/_jsxs("h3", {
        className: "mb-4",
        children: [/*#__PURE__*/_jsx("span", {
          children: rfaOwner.rfaOwnerName
        }), /*#__PURE__*/_jsx("span", {
          className: "separator"
        }), /*#__PURE__*/_jsx("span", {
          style: {
            fontWeight: 'normal'
          },
          children: rfaOwner.rfaOwnerRegistrationNumber
        })]
      }), /*#__PURE__*/_jsx(RequestTreeList, {
        history: history,
        getRfaOwnerName: getOrganisationName,
        getRfaOwnerRegistrationNumber: getOrganisationRegistrationNumber,
        organisations: props.organisations,
        requests: rfaOwner.rfaOwnerRequests,
        invitations: props.invitations,
        loading: props.loading
      })]
    }, index);
  });
  const content = props.error ? /*#__PURE__*/_jsx("span", {
    "data-id": "error-message",
    children: /*#__PURE__*/_jsx(Translate, {
      value: "error.generic"
    })
  }) : groupedList;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex-container space-between row",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "row col-12 mb-3 inline-container space-between",
        children: [/*#__PURE__*/_jsxs("h2", {
          "data-id": "active-requests",
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "project.page.requests"
          }), /*#__PURE__*/_jsx("span", {
            className: "separator information",
            children: props.requestsCount
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "inline-container",
          children: [props.project && /*#__PURE__*/_jsx(CreateRequestForApprovalButton, {
            color: "secondary",
            project: props.project,
            icon: "folder-plus"
          }), !props.loading && props.requests?.length > 0 && /*#__PURE__*/_jsxs("button", {
            type: "button",
            "data-id": "xlsxBtn",
            className: "large secondary inline-container",
            onClick: () => props.onDownloadXlsx(),
            children: [/*#__PURE__*/_jsx(Translate, {
              value: "project.exportExcel.title"
            }), /*#__PURE__*/_jsx(Icon, {
              icon: "download"
            })]
          })]
        })]
      }), content]
    })
  });
};
ProjectRequestListView.propTypes = {
  organisations: PropTypes.array.isRequired,
  requests: PropTypes.array.isRequired,
  invitations: PropTypes.array.isRequired,
  requestsCount: PropTypes.number.isRequired,
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    properties: projectPropertiesPropTypes().isRequired
  }),
  onDownloadXlsx: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired
};
export default ProjectRequestListView;